import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    (theme) => (
        {
            container: {
                marginTop: theme.spacing(12),
                marginBottom: theme.spacing(8),
            },
            text: {
                marginTop: theme.spacing(2),
                textIndent: theme.spacing(4),
                textAlign: 'justify',
            },
            bolder: {
                fontWeight: 'bold',
            },
            list: {
                listStyle: 'square',
                textIndent: theme.spacing(2),
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(8),
                ['@media (max-width:920px)']: { // eslint-disable-line no-useless-computed-key               
                    marginLeft: theme.spacing(4),
                },
            },
        }
    )
);

export default useStyles;